import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { Button } from './ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

const NotificationBell = () => {
  const { authFetch, user } = useAuth();
  const navigate = useNavigate();
  const [naoLidos, setNaoLidos] = useState(0);

  const fetchNaoLidos = useCallback(async () => {
    if (!user) return;
    // 2026-08 Perf: nao poll quando aba nao esta visivel
    if (document.hidden) return;

    try {
      const response = await authFetch('/mural/avisos/nao-lidos', {
        suppressAuthRedirect: true,
        timeout: 5000
      });
      setNaoLidos(response.data?.nao_lidos || 0);
    } catch (err) {
      console.error('Erro ao buscar notificações:', err);
    }
  }, [authFetch, user]);

  useEffect(() => {
    fetchNaoLidos();

    // 2026-08 Perf: 30s -> 90s + refetch imediato ao ganhar foco.
    // Reduz tráfego global em ~66% (era 2 pings/min por aba aberta).
    const interval = setInterval(fetchNaoLidos, 90000);
    const onVisChange = () => { if (!document.hidden) fetchNaoLidos(); };
    document.addEventListener('visibilitychange', onVisChange);
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisChange);
    };
  }, [fetchNaoLidos]);

  const handleClick = () => {
    navigate('/dashboard/mural');
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="relative"
            onClick={handleClick}
            data-testid="notification-bell"
          >
            <Bell className="h-5 w-5 text-gray-600" />
            {naoLidos > 0 && (
              <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-red-500 text-white text-xs flex items-center justify-center font-bold animate-pulse">
                {naoLidos > 9 ? '9+' : naoLidos}
              </span>
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{naoLidos > 0 ? `${naoLidos} aviso(s) não lido(s)` : 'Mural de Avisos'}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default NotificationBell;
